import { LocationEntity } from '../types';

export interface LocationHierarchyConfig {
    chinaLocationId: number;
    australiaLocationId: number;
    newZealandLocationId: number;
    southeastAsiaEastAsiaAndOceaniaLocationId: number;
    oceaniaLocationId: number;
}

/**
 * Applies workarounds to fix location hierarchy issues for specific countries.
 * Workaround #1: Rewrite location hierarchy for China
 * Workaround #2: Rewrite location hierarchy for Australia and New Zealand
 */
export const applyLocationHierarchyWorkarounds = (
    location: LocationEntity,
    config: LocationHierarchyConfig
): LocationEntity => {
    // Workaround #1: Rewrite location hierarchy for China
    if (location.level3_parent_id === config.chinaLocationId) {
        return {
            ...location,
            level: 4,
            level4_parent_id: 0,
        };
    }

    // Workaround #2: Rewrite location hierarchy for Australia and New Zealand
    if ([config.australiaLocationId, config.newZealandLocationId].includes(location.id)) {
        return {
            ...location,
            level1_parent_id: config.southeastAsiaEastAsiaAndOceaniaLocationId,
            level2_parent_id: config.oceaniaLocationId,
        };
    }

    return location;
};
